import styled, { css } from 'styled-components';
import { createGlobalStyle } from 'styled-components';

interface CalendarWrapper {
	$isOpenCalendar?: boolean;
}

export const CalendarWrapper = styled.div<CalendarWrapper>`
	visibility: hidden;
	opacity: 0;
	transition: opacity 0.3s ease-out;
	position: relative;

	${props =>
		props.$isOpenCalendar &&
		css`
			position: absolute;
			z-index: 2;
			visibility: visible;
			opacity: 1;
		`};
`;

export const GlobalStyle = createGlobalStyle`
	.rdp {
		height: 365px;
	}
`;
